// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3eWm8ShYYsEyX0y9F8eY6p{display:inline-block;background-repeat:no-repeat;background-size:100%;background-position:center}", ""]);
// Exports
exports.locals = {
	"Image": "_3eWm8ShYYsEyX0y9F8eY6p"
};
module.exports = exports;
